export default {
  data: [
    {
      id: '1',
      alias: 'Ene',
      month: 'Enero'
    },
    {
      id: '2',
      alias: 'Feb',
      month: 'Febrero'
    },
    {
      id: '3',
      alias: 'Mar',
      month: 'Marzo'
    },
    {
      id: '4',
      alias: 'Abr',
      month: 'Abril'
    },
    {
      id: '5',
      alias: 'May',
      month: 'Mayo'
    },
    {
      id: '6',
      alias: 'Jun',
      month: 'Junio'
    },
    {
      id: '7',
      alias: 'Jul',
      month: 'Julio'
    },
    {
      id: '8',
      alias: 'Ago',
      month: 'Agosto'
    },
    {
      id: '9',
      alias: 'Sep',
      month: 'Septiembre'
    },
    {
      id: '10',
      alias: 'Oct',
      month: 'Octubre'
    },
    {
      id: '11',
      alias: 'Nov',
      month: 'Noviembre'
    },
    {
      id: '12',
      alias: 'Dic',
      month: 'Diciembre'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/constants/months.js